export default "__VITE_ASSET__DQOwFtA2__"